import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";

// ----------------------------
//  AWS CONFIG for CRA
// ----------------------------
export const getAwsConfig = () => {
  const accessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY;
  const secretAccessKey = process.env.REACT_APP_AWS_SECRET_KEY;
  const region = process.env.REACT_APP_S3_AWS_REGION || "us-east-1";
  const bucket = process.env.REACT_APP_S3_BUCKET_NAME;
  const endpoint = process.env.REACT_APP_S3_BUCKET_ENDPOINT;

  if (!accessKeyId || !secretAccessKey) {
    throw new Error("Missing AWS credentials in .env file");
  }
  if (!bucket) {
    throw new Error("Missing REACT_APP_S3_BUCKET_NAME in .env");
  }

  return { accessKeyId, secretAccessKey, region, bucket, endpoint };
};

// ----------------------------
//  Create S3 Client
// ----------------------------
export const createS3Client = (cfg) => {
  return new S3Client({
    region: cfg.region,
    credentials: {
      accessKeyId: cfg.accessKeyId,
      secretAccessKey: cfg.secretAccessKey,
    },
    endpoint: cfg.endpoint,
    forcePathStyle: Boolean(cfg.endpoint),
  });
};

// ----------------------------
//  Upload Function
// ----------------------------
export const uploadToS3 = async ({ file, key, contentType, metadata }) => {
  const cfg = getAwsConfig();
  const s3 = createS3Client(cfg);

  console.log("Uploading to S3...", {
    key,
    bucket: cfg.bucket,
    region: cfg.region,
  });

  const arrayBuffer = await file.arrayBuffer();
  const body = new Uint8Array(arrayBuffer);

  const params = {
    Bucket: cfg.bucket,
    Key: key,
    Body: body,
    ContentType: contentType || file.type,
    Metadata: metadata,
  };

  const result = await s3.send(new PutObjectCommand(params));
  console.log("S3 Upload Result:", result);

  const url = cfg.endpoint
    ? `${cfg.endpoint}/${cfg.bucket}/${encodeURIComponent(key)}`
    : `https://${cfg.bucket}.s3.${cfg.region}.amazonaws.com/${encodeURIComponent(key)}`;

  return { key, url };
};
